<template>
  <div>
    <v-card>
      <v-card-text v-if="modo == 'ValidarEmail'">
        <div v-if="!message && !errorMessage">
          Aguarte un momento por favor . . .
        </div>
        <v-card-text>
          <v-alert type="success" v-if="message">
            {{ message }}
          </v-alert>
          {{ username }}
          <v-alert type="error" v-if="errorMessage">
            {{ errorMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            outlined
            @click="
              $router.push({
                path: '/login',
                query: { username }
              })
            "
            >Volver</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card>

    <v-card max-width="400" class="mx-auto mt-5" v-if="modo != 'ValidarEmail'">
      <v-card-title>
        <h2 class="subtitle-1">Validar número de celular</h2>
      </v-card-title>

      <v-card-text>
        <p>
          Falta un paso más, favor valide su número de celular con los registros
          de la base de datos de APA
        </p>
        <v-form ref="form" v-model="validForm">
          <v-text-field
            disabled
            v-model="celular"
            :rules="[rules.required, rules.celular, rules.number]"
            type="text"
            label="Número de celular"
            autofocus
            prepend-icon="phone"
          />

          <v-text-field
            v-if="modo == 'ValidarCelular'"
            v-model="pin"
            :rules="[rules.required, rules.pin, rules.number]"
            type="text"
            label="Ingrese el pin"
            autofocus
            prepend-icon="sms"
          />
        </v-form>
        <v-alert type="error" v-if="errorMessage">
          {{ errorMessage }}
        </v-alert>
        <v-alert type="success" v-if="message">
          {{ message }}
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primary"
          outlined
          @click="
            $router.push({
              path: '/login',
              query: { username }
            })
          "
          >Volver</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          v-if="modo == 'SolicitarPin'"
          @click="solicitarPinCelular"
          >SOLICITAR PIN</v-btn
        >
        <v-btn
          v-if="modo == 'ValidarCelular' && message == ''"
          :disabled="!validForm"
          color="primary"
          @click="validar"
          >VALIDAR</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "../axios-auth";
export default {
  data() {
    return {
      modo: "ValidarEmail",
      username: "",
      celular: "",
      errorMessage: "",
      message: "",
      pin: "",
      validForm: false,
      rules: {
        required: value => !!value || "Requerido.",
        celular: value =>
          value.length == 10 || "Ingrese un número valido ej. 09XXXXXX",
        number: value => {
          const pattern = /^[0-9]+$/;
          return pattern.test(value) || "Ingrese solo números";
        },
        pin: value => {
          return (
            value.length == 3 || "Número de 5 digitis recibio en su celular"
          );
        }
      }
    };
  },
  mounted() {
    if (this.$route.query.token) {
      axios
        .get(`/singup/validarEmail?token=${this.$route.query.token}`)
        .then(response => {
          this.message = "";
          this.errorMessage = "";

          if (response.data.emailVerificado) {
            this.message =
              "¡Tu dirección de correo está confirmada! Tenemos que hacerte algunas preguntas por seguridad. Un personal autorizado de APA va a llamarte al número de celular que facilitaste (la llamada será en las siguientes 24 horas).";
          }
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    } else {
      //this.$router.push("/login");
    }
  },
  methods: {
    // solicitarPinCelular() {
    //   //this.snackbar = true;
    //   //this.$store.dispatch("showSnack", "Solicitud recibida!");
    //   axios
    //     .post("/singup/solicitarPinCelular", {
    //       username: this.username,
    //       celular: this.celular
    //     })
    //     .then(() => {
    //       this.modo = "ValidarCelular";
    //       this.errorMessage = "";
    //     })
    //     .catch(err => {
    //       if (err.response.data) {
    //         this.errorMessage = err.response.data;
    //       } else {
    //         this.errorMessage = "Error";
    //       }
    //       console.log(err);
    //     });
    // },
    // validar() {
    //   axios
    //     .post("/singup/validarCelular", {
    //       username: this.username,
    //       celular: this.celular,
    //       token: this.pin
    //     })
    //     .then(response => {
    //       this.modo = "ValidarCelular";
    //       this.errorMessage = "";
    //       this.message = "";
    //       if (response.data.estado == "Habilitado") {
    //         this.message =
    //           "Bienvenido " +
    //           response.data.nombre +
    //           ". Ya puede iniciar sesion";
    //       } else {
    //         this.errorMessage = "Error";
    //       }
    //     })
    //     .catch(err => {
    //       if (err.response.data) {
    //         this.errorMessage = err.response.data;
    //       } else {
    //         this.errorMessage = "Error";
    //       }
    //       console.log(err);
    //     });
    // }
  }
};
</script>
